import { wccModules } from 'enums/wccModules';
import { Subscribable } from 'knockout';
import Task from 'models/task';
import WCCError from 'models/wccError';
import { TasksService } from 'services/tasks';
import { createExtendedContainer } from '../configuration/inversify/container/extended';
import { CurrentUserManager } from './currentUser';
import { IWCCStorageManager } from './iStorage';
import TaskManager from './task';

export default class AdminAccessManager {
    private tasksService: TasksService

    private task: Subscribable<Task | undefined>
    private moderatorAccessTypes: Subscribable<Array<string>>
    private observerAccessTypes: Subscribable<Array<string>>
    private currentUserStatus: Subscribable<number | undefined>

    dispose: Action

    hasAccess: Subscribable<boolean>
    ready: Subscribable<boolean>

    constructor() {
        const [container, disposeContainer] = createExtendedContainer();
        this.dispose = disposeContainer;

        this.tasksService = container.get(wccModules.tasksService);

        const storage = <IWCCStorageManager>container.get(wccModules.storage);
        const { discussionId } = settings;

        const taskManager = storage.get(TaskManager, { taskId: discussionId });
        this.task = taskManager.pluck(m => m.task);
        const discussionReady = this.task.isNotNull();
        this.moderatorAccessTypes = this.task.pluck(t => t.moderatorAccessTypes, []);
        this.observerAccessTypes = this.task.pluck(t => t.observerAccessTypes, []);

        const currentUserManager = storage.get(CurrentUserManager, { discussionId });
        const currentUser = currentUserManager.pluck(m => m.person);
        const currentUserReady = currentUser.isNotNull();
        this.currentUserStatus = currentUser.pluck(u => u.status);

        this.hasAccess = ko.pureComputed(() => this.checkIfHasAccess());
        this.ready = ko.pureComputed(() => discussionReady() && currentUserReady());
    }

    async requestAccess() {
        try {
            if (!this.hasAccess())
                throw new WCCError(messages.PermissionDenied);

            const task = this.task();

            if (task == undefined)
                throw new WCCError(messages.UnknownError);

            const query = this.getQuery();

            if (query == undefined)
                throw new WCCError(messages.UnknownError);

            const response = await query.post({ TaskId: <string>task.id(), AccountDNS: <string>task.accountDNS() });
            const url = response.Data;

            if (!response.IsRequestSuccessful || response.Data == undefined)
                throw new WCCError(response.Message);

            $.fancybox.open(
                <any>{
                    type: 'html',
                    content: '<div>' + labels.TheModObsToolsWillBeOpenedInANewWindow
                        .replace('{0}', this.getTitle())
                        .replace('{1}', url)
                        .replace('{2}', ' target="_blank" onclick="$.fancybox.close();"') + '</div>'
                }, <any>{ padding: 20 });
        } catch (ex) {
            system.handleError(ex);
        }
    }

    checkIfHasAccess() {
        switch (this.currentUserStatus()) {
            case enums.MembershipStatusTypes.Moderator.value: return this.moderatorAccessTypes().length > 0;
            case enums.MembershipStatusTypes.Observer.value: return this.observerAccessTypes().length > 0;
            default: return false;
        }
    }

    getQuery() {
        switch (this.currentUserStatus()) {
            case enums.MembershipStatusTypes.Moderator.value: return this.tasksService.queries.moderatorLogin();
            case enums.MembershipStatusTypes.Observer.value: return this.tasksService.queries.observerLogin();
        }
    }

    getTitle() {
        switch (this.currentUserStatus()) {
            case enums.MembershipStatusTypes.Moderator.value: return labels.ModeratorTools;
            case enums.MembershipStatusTypes.Observer.value: return labels.ObserverTools;
            default: return '';
        }
    }
}